import configs from "./configs";

const CACHE_KEY = "cfl:geo-check";

export const COUNTRY_NAMES: Record<string, string> = {
  US: "the United States",
  ID: "Indonesia",
  KP: "North Korea",
  IR: "Iran",
  CU: "Cuba",
  SY: "Syria",
  RU: "Russia",
  BY: "Belarus",
  MM: "Myanmar",
  VE: "Venezuela",
  AF: "Afghanistan",
  CF: "Central African Republic",
  CD: "Democratic Republic of the Congo",
  IQ: "Iraq",
  LB: "Lebanon",
  LY: "Libya",
  ML: "Mali",
  NI: "Nicaragua",
  SO: "Somalia",
  SS: "South Sudan",
  SD: "Sudan",
  YE: "Yemen",
  ZW: "Zimbabwe",
};

export const ALLOWED_ROUTES = [
  "/",
  "/terms-of-service",
  "/privacy-policy",
  "/responsible-gaming-policy",
];

export type GeoCheckResult = {
  country: string | null;
  isBlocked: boolean;
};

export function isAllowedRoute(pathname: string) {
  return ALLOWED_ROUTES.some(
    (route) => pathname === route || pathname.startsWith(`${route}/`),
  );
}

export async function checkGeolocation(): Promise<GeoCheckResult> {
  if (!configs?.GEO_BLOCK?.enabled) {
    return { country: null, isBlocked: false };
  }

  const blockedCountries = new Set(configs.GEO_BLOCK.blockedCountries);

  // Check sessionStorage cache first
  try {
    const cached = sessionStorage.getItem(CACHE_KEY);
    if (cached) {
      const parsed = JSON.parse(cached) as GeoCheckResult;
      return {
        ...parsed,
        isBlocked:
          parsed.country !== null && blockedCountries.has(parsed.country),
      };
    }
  } catch {
    // Ignore storage errors
  }

  // Fetch country from Cloudflare trace (free, no API key)
  try {
    const response = await fetch("https://cloudflare.com/cdn-cgi/trace");
    const text = await response.text();
    const country = text.match(/loc=(\w+)/)?.[1] ?? null;
    const result: GeoCheckResult = {
      country,
      isBlocked: country !== null && blockedCountries.has(country),
    };

    try {
      sessionStorage.setItem(CACHE_KEY, JSON.stringify(result));
    } catch {
      // Ignore storage errors
    }

    return result;
  } catch {
    // Fail-open: if the API is unreachable, allow through
    return { country: null, isBlocked: false };
  }
}
